import { call, put, delay, takeLatest } from 'redux-saga/effects';
import { getVerdict } from '../api/scanApi';
import { SCAN_START, SCAN_SUCCESS, SCAN_FAILURE } from '../actions/scanActions';

function* runScan(action) {
  const { steamId, locale } = action.payload;
  try {
    // On laisse l'animation de scan respirer (le "choc" a besoin d'un temps de latence).
    yield delay(1600);
    const { data } = yield call(getVerdict, steamId, locale);
    yield put({ type: SCAN_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: SCAN_FAILURE, payload: 'scan_failed' });
  }
}

export default function* scanSaga() {
  yield takeLatest(SCAN_START, runScan);
}
